import { Link } from "react-router-dom";
import { Boxes } from "lucide-react";
import { TOOLS } from "@/lib/tools";

export const Header = () => {
  return (
    <header className="sticky top-0 z-40 border-b bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2 font-heading font-semibold text-lg">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <Boxes className="h-4 w-4" />
          </span>
          <span>Rechnerkiste</span>
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/#tools" data-testid="header-nav-tools-link" className="text-muted-foreground hover:text-foreground transition-colors">Tools</Link>
          <Link to="/datenschutz" data-testid="header-nav-datenschutz-link" className="text-muted-foreground hover:text-foreground transition-colors hidden sm:inline">Datenschutz</Link>
          <Link to="/impressum" data-testid="header-nav-impressum-link" className="text-muted-foreground hover:text-foreground transition-colors hidden sm:inline">Impressum</Link>
        </nav>
      </div>
    </header>
  );
};

export const Footer = () => {
  const cats = [...new Set(TOOLS.map((t) => t.cat))];
  const grouped = cats.map((c) => ({ cat: c, items: TOOLS.filter((t) => t.cat === c) }));
  return (
    <footer className="border-t bg-background mt-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8">
          <div className="sm:max-w-xs">
            <div className="font-heading font-semibold">Rechnerkiste</div>
            <p className="mt-2 text-xs text-muted-foreground">
              Über {TOOLS.length} kostenlose Rechner für Alltag, Heimwerken, Küche, Umzug und Finanzen. Ohne Anmeldung.
            </p>
            <nav className="mt-4 flex gap-4 text-sm text-muted-foreground">
              <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-foreground">Datenschutz</Link>
              <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-foreground">Impressum</Link>
            </nav>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 text-sm">
            {grouped.map(({ cat, items }) => (
              <div key={cat}>
                <div className="font-medium mb-2">{cat}</div>
                <ul className="space-y-1.5">
                  {items.map((t) => (
                    <li key={t.id}>
                      <a href={t.url} className="text-muted-foreground hover:text-foreground" data-testid={`footer-tool-${t.id}`}>
                        {t.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
